const state = {
	// 版本号
	version: null,
	// SOL价格
	solPrice: 0
}

const getters = {
	version: state => state.version,
	solPrice: state => {
		if(state.solPrice != null && state.solPrice != 0) {
			return state.solPrice;
		}
		state.solPrice = JSON.parse(localStorage.getItem("artwormz-solPrice"));
		return state.solPrice;
	},
}

const actions = {
	versionHandler(context, payload){
		context.commit('versionHandler', payload);
	},
	solPriceHandler(context, payload){
		context.commit('solPriceHandler', payload);
	}
}

const mutations = {
	versionHandler(state, version){
		state.version = version;
	},
	solPriceHandler(state, solPrice){
		localStorage.setItem("artwormz-solPrice", JSON.stringify(solPrice));
		state.solPrice = solPrice;
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/data/index.js